import { render, staticRenderFns } from "./bankSaman.vue?vue&type=template&id=a09a1440"
import script from "./bankSaman.vue?vue&type=script&lang=js"
export * from "./bankSaman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports